/** Holds system level base infos. */
import _ from 'lodash'
import { xhrGet } from '../../util/xhr-apis'

/** initial state */
const state = {
  examTargets: [],
  examTimes: [],
  questionTypes: [],
  schoolTypes: [],
  grades: [],
  terms: [],
  majorTypes: [],
  majorTypeMajors: {},
  publicMajor: { value: 0, name: '文化课' },
  majorSubjects: {},
  publicSubjects: [],
  knowledgePoints: [],
  provinces: [],
  provinceCities: {}
}

/** getters */
// const getters = {}

/**
 * Template method for fetch and cache base datas.
 * @param {*} state vue state
 * @param {*} commit vue commit
 */
let xhrSetActionHelper = (state, commit, stateName, url) => {
  if (!_.isEmpty(state[stateName])) {
    // console.log(`using ${stateName} cache...`)
    return Promise.resolve(state[stateName])
  }
  return xhrGet(url)
    .then(rs => {
      let rsData = rs.data
      let mutationName = 'set' + _.upperFirst(stateName)
      commit(mutationName, rsData)
      return rsData
    }).catch(err => console.log('error: ' + err))
}

let xhrMapActionHelper = (state, commit, stateName, mapKey, url) => {
  let values = state[stateName][mapKey]
  if (_.isEmpty(values)) {
    return xhrGet(url)
      .then(rs => {
        values = rs.data
        let mutationName = 'set' + _.upperFirst(stateName)
        commit(mutationName, { k: mapKey, v: values })
        return values
      }).catch(err => console.log('error: ' + err))
  } else {
    return Promise.resolve(values)
  }
}

/** actions */
const actions = {
  xhrExamTargets ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'examTargets', '/exams/targets')
  },

  xhrExamTimes ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'examTimes', '/exams/times')
  },

  xhrQuestionTypes ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'questionTypes', '/exams/questions/types')
  },

  xhrGrades ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'grades', '/schools/grades')
  },

  xhrTerms ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'terms', '/schools/terms')
  },

  xhrSchoolTypes ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'schoolTypes', '/schools/types')
  },

  xhrMajorTypes ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'majorTypes', '/majors/types')
  },

  xhrMajorTypeMajors ({ state, commit }, majorTypeId) {
    return xhrMapActionHelper(state, commit, 'majorTypeMajors', majorTypeId, `/majors/types/${majorTypeId}`)
  },

  xhrMajorSubjects ({ state, commit }, majorId) {
    return xhrMapActionHelper(state, commit, 'majorSubjects', majorId, `/majors/${majorId}/subjects`)
  },

  xhrPublicSubjects ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'publicSubjects', '/majors/public/subjects')
  },

  xhrKnowledgePoints ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'knowledgePoints', '/knowledges/points')
  },

  xhrProvinces ({ state, commit }) {
    return xhrSetActionHelper(state, commit, 'provinces', '/regions/provinces')
  },

  xhrCities ({ state, commit }, provinceId) {
    return xhrMapActionHelper(state, commit, 'provinceCities', provinceId, `/regions/provinces/${provinceId}/cities`)
  }
}

/** mutations */
const mutations = {
  setExamTargets (state, examTargets) { state.examTargets = examTargets },
  setExamTimes (state, examTimes) { state.examTimes = examTimes },
  setQuestionTypes (state, questionTypes) { state.questionTypes = questionTypes },

  setGrades (state, grades) { state.grades = grades },
  setTerms (state, terms) { state.terms = terms },
  setSchoolTypes (state, types) { state.schoolTypes = types },

  setMajorTypes (state, majorTypes) { state.majorTypes = majorTypes },
  setMajorTypeMajors (state, payload) { state.majorTypeMajors[payload.k] = payload.v },
  setMajorSubjects (state, payload) { state.majorSubjects[payload.k] = payload.v },
  setPublicSubjects (state, publicSubjects) { state.publicSubjects = publicSubjects },

  setKnowledgePoints (state, knowledgePoints) { state.knowledgePoints = knowledgePoints },

  setProvinces (state, provinces) { state.provinces = provinces },
  setProvinceCities (state, payload) { state.provinceCities[payload.k] = payload.v }
}

/* export for using */
export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/sso/store/modules/base-info.js